import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { CloseIcon, ScheduleIcon } from "../assets/Icons";
import { SERVER_IP, ud, jwt } from "../Server";
import axios from "axios";
import moment from "moment/moment";

const executionType = {
  null: null,
  "null": "null",
  "DOES_NOT_REPEAT": "DOES_NOT_REPEAT",
  "DAILY": "daily",
  "WEEKLY": "weekly",
  "MONTHLY": "monthly",
  "WEEKDAY": "weekday",
  "YEARLY": "yearly",
  "CUSTOM": "custom",
}

const ScheduleRecurrenceModal = ({ show, onClose, workflow_id, version_id, scheduleData, getWorkflowSchedule }) => {
  const [modalShow, setModalShow] = useState(show);
  const [repeat, setRepeat] = useState("DOES_NOT_REPEAT");
  const [notificationBefore, setNotificationBefore] = useState("");
  const [repeatEvery, setRepeatEvery] = useState(1);
  const [repeatUnit, setRepeatUnit] = useState("week");
  const [selectedDays, setSelectedDays] = useState(["sun"]);
  const [endsNever, setEndsNever] = useState(true);
  const [endsOnDate, setEndsOnDate] = useState(0);
  const [date, setDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const [startTime, setStartTime] = useState("");

  const [repeatOptions, setRepeatOptions] = useState([
    { value: "DOES_NOT_REPEAT", label: "Does not repeat" },
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly on Thursday" },
    { value: "monthly", label: "Monthly on the third Thursday" },
    { value: "yearly", label: "Annually on September 18" },
    { value: "weekday", label: "Every weekday (Monday to Friday)" },
    { value: "custom", label: "Custom..." },
  ]);

  const [days, setDays] = useState([
    { id: "sun", label: "S" },
    { id: "mon", label: "M" },
    { id: "tue", label: "T" },
    { id: "wed", label: "W" },
    { id: "thu", label: "T" },
    { id: "fri", label: "F" },
    { id: "sat", label: "S" },
  ]);

  function getDateAfter15Min() {
    let now = new Date();
    // Add 15 minutes
    now.setMinutes(now.getMinutes() + 15);
    const dateStr = now.toISOString().split("T")[0];
    // Format time → HH:mm
    const timeStr = now.toTimeString().slice(0, 5);
    setDate(dateStr);
    setStartTime(timeStr);
  }


  const getTodayDayName = () => {
    const date = new Date();
    const month = date.getMonth();
    const dayNumber = date.getDay();
    const dayOfMonth = date.getDate();
    const firstDayOfMonth = new Date(date.getFullYear(), month, 1);
    const weekdayOfFirstDay = firstDayOfMonth.getDay();
    const adjustedDay = dayOfMonth + weekdayOfFirstDay;
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const ordinals = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh'];
    const currentMonth = date.toLocaleDateString('en-US', { month: 'long' });
    let weekNumber = Math.ceil(adjustedDay / 7);
    let weekDay = ordinals[Math.min(weekNumber - 1, ordinals.length - 1)];
    let currentDay = days[dayNumber];

    setRepeatOptions([
      { value: "DOES_NOT_REPEAT", label: "Does not repeat" },
      { value: "daily", label: "Daily" },
      { value: "weekly", label: `Weekly on ${currentDay}` },
      { value: "monthly", label: `Monthly on the ${weekDay} ${currentDay}` },
      { value: "yearly", label: `Annually on ${currentMonth} ${dayOfMonth}` },
      { value: "weekday", label: "Every weekday (Monday to Friday)" },
      { value: "custom", label: "Custom..." },
    ]);

  }

  useEffect(() => {

    if (scheduleData) {
      const dateObj = scheduleData.create_execution;
      const dateTime = dateObj.split(" ");
      const timeOnly = (dateTime[1]).slice(0, 5);
      setDate(dateTime[0]);
      setStartTime(timeOnly);
      setRepeat(executionType[scheduleData.execution_type]);
      if (scheduleData.execution_type == "CUSTOM") {
        setRepeatEvery(scheduleData.interval_value);
        setRepeatUnit(scheduleData.interval_type);
        setSelectedDays(scheduleData.interval_days.interval_days);
        handleSelectCustomEnds(scheduleData.interval_end_type);
        setEndsOnDate(scheduleData.interval_end_value);
      }

    } else {
      getTodayDayName();
      getDateAfter15Min();
    }
  }, [scheduleData]);

  useEffect(() => {
    setModalShow(show);
  }, [show]);

  const handleDayToggle = (dayId) => {
    setSelectedDays((prev) => (prev.includes(dayId) ? prev.filter((d) => d !== dayId) : [...prev, dayId]));
  };

  const handleSelectCustomEnds = (value) => {
    setEndsOnDate(0);
    setEndsNever(value)
  }

  const handleCreate = async () => {
    try {
      let bodyData = {
        workflow_id,
        version_id,
        is_repeated: repeat === "DOES_NOT_REPEAT" ? false : true,
        execution_time: moment(`${date} ${startTime}`, "YYYY-MM-DD hh:mm").toISOString(),
        // execution_time: new Date(`${date}T${startTime}:00`),
        execution_type: repeat,
        custom: repeat === "custom" ? {
          interval_value: repeatEvery,
          interval_type: repeatUnit,
          interval_days: repeatUnit !== "day" ? selectedDays : days.map(e => e.id),
          interval_end_type: endsNever,
          interval_end_value: endsOnDate
        }
          :
          null
      }

      let headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };

      await axios.post(`${SERVER_IP}/workflow/schedule/create`, bodyData, { withCredentials: true, headers: headers })
      if (getWorkflowSchedule) getWorkflowSchedule();
      onClose();

    } catch (error) {
      console.log(error);
    }

  }

  const handleUpdate = async () => {
    try {
      let bodyData = {
        version_id,
        is_repeated: repeat === "DOES_NOT_REPEAT" ? false : true,
        execution_time: new Date(`${date}T${startTime}:00`),
        execution_type: repeat,
        custom: repeat === "custom" ? {
          interval_value: repeatEvery,
          interval_type: repeatUnit,
          interval_days: repeatUnit !== "day" ? selectedDays : days.map(e => e.id),
          interval_end_type: endsNever,
          interval_end_value: endsOnDate
        }
          :
          null
      }

      let headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };

      await axios.post(`${SERVER_IP}/workflow/schedule/update/${workflow_id}`, bodyData, { withCredentials: true, headers: headers })
      if (getWorkflowSchedule) getWorkflowSchedule();
      onClose();

    } catch (error) {
      console.log(error);
    }

  }

  return (
    <Modal className="schedulerec" show={modalShow} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title className="title modal-title">Schedule Recurrence</Modal.Title>
        <button
          onClick={onClose}
          className="close-s schedule-modal-button"
          type="button"
          data-toggle="tooltip"
          data-placement="top"
          title="Close"
        >
          <CloseIcon />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="date-time-range">
          <div className="date-wrapper">
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="date-input form-control"
            />
          </div>
          <div className="time-wrapper">
            <input
              type="time"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              className="time-input form-control"
            />
          </div>
        </div>

        <div className="d-flex align-items-center gap-1 pt-2">
          <input
            type="checkbox"
            id="allDay"
            checked={repeat === "daily" ? true : false}
            style={{
              width: "18px",
              height: "18px",
              accentColor: "#2f3a79",
              borderRadius: "1rem",
            }}
            onChange={() => setRepeat(repeat === "daily" ? "DOES_NOT_REPEAT" : "daily")}
          />
          <label htmlFor="allDay" className="end" style={{ margin: 0 }}>
            Every Day
          </label>
        </div>

        <Form.Control
          className="selectconditionsrepeat"
          as="select"
          value={repeat}
          onChange={(e) => setRepeat(e.target.value)}
        >
          {repeatOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Control>

        {repeat === "custom" && (
          <>
            <h5 className="mt-3">Recurrence Pattern</h5>
            <h6 className="text-muted mb-1 mt-2">Repeat every</h6>
            <Form.Group as={Row}>
              <Col xs={6} className="every-label">
                <div className="d-flex align-items-center gap-1">
                  <Form.Control
                    type="number"
                    min="1"
                    value={repeatEvery}
                    onChange={(e) => setRepeatEvery(Number(e.target.value))}
                  />
                </div>
              </Col>
              <Col xs={6}>
                <Form.Control
                  as="select"
                  value={repeatUnit}
                  onChange={(e) => setRepeatUnit(e.target.value)}
                  className="form-control"
                  style={{ width: "100%" }}
                >
                  <option value="day">Day</option>
                  <option value="week">Week</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </Form.Control>
              </Col>
            </Form.Group>

            {repeatUnit !== "day" && <div>
              <Form.Label className="text-muted f-1 ">Repeat on</Form.Label>
              <div className="d-flex flex-wrap justify-content-start gap-2">
                {days.map((day) => (
                  <button
                    key={day.id}
                    type="button"
                    onClick={() => handleDayToggle(day.id)}
                    className={`rounded-circle p-2 week-color ${selectedDays.includes(day.id) ? "active" : ""}`}
                  // style={{
                  //   // width: 36,
                  //   // height: 36,
                  //   // display: "flex",
                  //   // justifyContent: "center",
                  //   // alignItems: "center",
                  //   // border: "none",
                  // }}
                  >
                    {day.label}
                  </button>
                ))}
              </div>
            </div>}


            <Form.Group className="mt-4">
              <Form.Label className="text-muted">Ends</Form.Label>
              <div className="d-flex flex-column gap-1">
                <div className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    id="ends-never"
                    name="ends"
                    checked={endsNever === "never"}
                    onChange={() => handleSelectCustomEnds("never")}
                    style={{
                      width: "18px",
                      height: "18px",
                      accentColor: "#2f3a79",
                      borderRadius: "50%",
                    }}
                  />
                  <label htmlFor="ends-never" className="end m-0">
                    Never
                  </label>
                </div>

                <div className="d-flex justify-content-between">
                  <div className="d-flex align-items-center gap-1">
                    <input
                      type="radio"
                      id="ends-on"
                      name="ends"
                      checked={endsNever === "on"}
                      onChange={() => handleSelectCustomEnds("on")}
                      style={{
                        width: "18px",
                        height: "18px",
                        accentColor: "#2f3a79",
                        borderRadius: "50%",
                      }}
                    />
                    <label htmlFor="ends-on" className="end m-0">
                      On
                    </label>
                  </div>

                  <input
                    type="date"
                    value={endsOnDate}
                    onChange={(e) => setEndsOnDate(e.target.value)}
                    className="date-input form-control"
                    style={{ marginLeft: "1rem", width: "50%" }}
                    disabled={endsNever !== "on"}
                  />

                </div>

                <div className="d-flex justify-content-between">
                  <div className="d-flex align-items-center gap-1">
                    <input
                      type="radio"
                      id="ends-after"
                      name="ends"
                      checked={endsNever === "after"}
                      onChange={() => handleSelectCustomEnds("after")}
                      style={{
                        width: "18px",
                        height: "18px",
                        accentColor: "#2f3a79",
                        borderRadius: "50%",
                      }}
                    />
                    <label htmlFor="ends-after" className="end m-0">
                      After
                    </label>
                  </div>

                  <input
                    type="number"
                    min="1"
                    // value={`2`}
                    value={endsOnDate}
                    onChange={(e) => setEndsOnDate(e.target.value)}
                    className="date-input form-control"
                    style={{ marginLeft: "1rem", width: "50%" }}
                    disabled={endsNever !== "after"}
                  />
                </div>
              </div>
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="mt-4">
        {scheduleData ?
          <Button variant="primary" onClick={handleUpdate}> Update </Button>
          :
          <Button variant="primary" onClick={handleCreate}> Create </Button>
        }
      </Modal.Footer>
    </Modal>
  );
};

export default ScheduleRecurrenceModal;
